import { useMemo, useState } from 'react';

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}/;

function compareValues(a, b) {
  if (a === null || a === undefined || a === '') return b === null || b === undefined || b === '' ? 0 : 1;
  if (b === null || b === undefined || b === '') return -1;
  if (typeof a === 'number' && typeof b === 'number') return a - b;
  if (typeof a === 'boolean' || typeof b === 'boolean') return a === b ? 0 : a ? 1 : -1;

  const aStr = String(a);
  const bStr = String(b);
  if (ISO_DATE_RE.test(aStr) && ISO_DATE_RE.test(bStr)) {
    const aTime = Date.parse(aStr);
    const bTime = Date.parse(bStr);
    if (!Number.isNaN(aTime) && !Number.isNaN(bTime)) return aTime - bTime;
  }
  return aStr.localeCompare(bStr, 'da-DK', { sensitivity: 'base', numeric: true });
}

/**
 * Generic click-to-sort helper for data tables.
 * `initial.key` picks the starting sort column; clicking the same column again flips direction.
 */
export function useSortableData(items, initial = {}) {
  const { key: initialKey = null, dir: initialDir = 'desc' } = initial;
  const [sortKey, setSortKey] = useState(initialKey);
  const [sortDir, setSortDir] = useState(initialDir);

  const sorted = useMemo(() => {
    if (!Array.isArray(items) || !sortKey) return items || [];
    const copy = [...items];
    copy.sort((a, b) => {
      const result = compareValues(a?.[sortKey], b?.[sortKey]);
      return sortDir === 'asc' ? result : -result;
    });
    return copy;
  }, [items, sortKey, sortDir]);

  function toggleSort(key) {
    if (key === sortKey) {
      setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortKey(key);
      setSortDir('desc');
    }
  }

  return { sorted, sortKey, sortDir, toggleSort };
}
